import { createTRPCReact, httpBatchLink } from '@trpc/react-query'
import type { inferRouterOutputs } from '@trpc/server'
import type { AppRouter } from '@warrantly/server/trpc'
import superjson from 'superjson'
import { API_URL } from '@/config'

export const trpc = createTRPCReact<AppRouter>()

export type RouterOutputs = inferRouterOutputs<AppRouter>

export const trpcClient = trpc.createClient({
	links: [
		httpBatchLink({
			url: `${API_URL}/api/trpc`,
			transformer: superjson,
			async fetch(url, options) {
				return fetch(url, {
					...options,
					credentials: 'include',
				})
			},
		}),
	],
})
